module.exports = __webpack_public_path__ + "img/index_top.7ceb3e53.png";